import { render, staticRenderFns } from "./CompetitionEmptySearchLayout.vue?vue&type=template&id=219b813e&scoped=true"
import script from "./CompetitionEmptySearchLayout.vue?vue&type=script&lang=js"
export * from "./CompetitionEmptySearchLayout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "219b813e",
  null
  
)

export default component.exports